var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelfEnrollIcon = function SvgSelfEnrollIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6,
    x: 1,
    fill: "#1e88e5",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M15.824 10.204v3.556a.688.688 0 0 1-1.376 0v-3.556a6.44 6.44 0 0 0-2.064-4.7v5.018a.688.688 0 0 1-1.263.377l-.919-1.403-.02-.033a1.032 1.032 0 0 0-1.796 1.018l1.903 2.906a.688.688 0 0 1-1.151.753l-1.915-2.924-.02-.033a3 3 0 0 1-.09-.172H.687A.69.69 0 0 1 0 10.323V1.376A1.376 1.376 0 0 1 1.376 0h4.128v4.128a.688.688 0 0 0 1.376 0V0h4.128a1.376 1.376 0 0 1 1.376 1.376v2.375a7.82 7.82 0 0 1 3.44 6.453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M.5 1 6 7M6 7l5.9-6"
  })));
};
export default SvgSelfEnrollIcon;